import Props from './types';
import S from './VehicleStyles';

function Vehicle({
  imageSrc,
  licensePlateNumber,
  model,
}: Props):JSX.Element {
  return (
    <S.Wrapper>
      <div className="avatar">
        <img src={imageSrc} alt="vehicle" />
      </div>
      <div className="description">
        <p className="title" title={licensePlateNumber}>{ licensePlateNumber }</p>
        <p className="subtitle" title={model}>{ model }</p>
      </div>
    </S.Wrapper>
  );
}

export default Vehicle;
